import { useMutation } from '@tanstack/react-query';

import { useApi } from '@/context';

/**
 * Open the Stripe Billing Portal (ESCLOUD-290). The caller redirects to the
 * returned URL — everything done inside the Portal reaches this app back as
 * webhook-synced subscription state, so nothing is cached or invalidated here.
 */
export function useCreatePortalSession(tenantId: string) {
    const api = useApi();

    return useMutation({
        mutationFn: () => api.billing.createPortalSession(tenantId),
    });
}
